export default __webpack_public_path__ + "static/media/SmallCTAcceptableMovementEdited.0cca90ca.png";